import { Row, Collapse } from 'antd'
import styled from 'styled-components'

const WrapCollapsePanel = styled(Collapse.Panel)<{ highlight?: boolean }>`
  ${({ highlight }) => {
    if (highlight) {
      return { backgroundColor: '#b7eb8f' }
    }
  }}
  border-radius: 4;
  border: '1px dashed #e8e8e8';
  margin-bottom: 24;
  overflow: 'hidden';
`

const WrapInputJustification = styled.div`
  padding: 5px;
`

const WrapRow = styled(Row)`
  background: #fbfbfb;
  border-radius: 4;
  border: '1px dashed #e8e8e8';
  overflow: 'hidden';
  padding: 16;
`

export { WrapCollapsePanel, WrapInputJustification, WrapRow }
